const Portis = () => (
    <svg
        width='24'
        height='37'
        viewBox='0 0 24 37'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='portis'
    >
        <path
            opacity='0.1'
            d='M0.358398 21.3948L3.22661 20.4329L11.9997 25.6317L20.7952 20.4329L23.5739 21.3948L11.9997 28.3208L0.358398 21.3948Z'
            fill='#fff'
        />
        <path
            d='M10.6006 11.583L11.9997 12.2287L10.4033 12.9462V11.5112L10.6006 11.583Z'
            fill='#fff'
        />
        <path
            opacity='0.2'
            d='M12 13.9688V25.6279L23.1569 19.045L12 13.9688Z'
            fill='#fff'
        />
        <path
            opacity='0.6'
            d='M12 0.533691V13.9687L23.1569 19.0449L12 0.533691Z'
            fill='#fff'
        />
        <path
            opacity='0.5'
            d='M11.9997 13.9688V25.6279L10.4033 24.6952L0.860711 19.045H0.842773L0.860711 19.027L10.4033 14.7042L11.9997 13.9688Z'
            fill='#fff'
        />
        <path
            d='M11.9997 0.533691V13.9687L0.842773 19.0449L11.9997 0.533691Z'
            fill='#fff'
        />
        <path
            d='M7.47998 35.8701C7.64142 35.9419 7.82079 36.0136 7.98222 36.0854C7.82079 36.0136 7.65935 35.9419 7.47998 35.8701Z'
            fill='#fff'
        />
        <path
            d='M7.98242 36.0674C8.14386 36.1391 8.32323 36.1929 8.5026 36.2468C8.32323 36.1929 8.16179 36.1391 7.98242 36.0674Z'
            fill='#fff'
        />
        <path
            d='M8.95068 36.3901C9.09418 36.426 9.21974 36.4619 9.3453 36.4978L8.95068 36.3901Z'
            fill='#fff'
        />
        <path
            d='M0.358744 21.3948L12 28.2827C11.8386 29.323 11.5695 30.3454 11.1569 31.332C10.2242 33.5921 8.34081 35.9598 4.69955 34.1481C1.73991 31.7266 0.0179372 28.1033 0 24.2827C0 23.3141 0.125561 22.3454 0.358744 21.3948Z'
            fill='#fff'
        />
        <path
            opacity='0.8'
            d='M19.2642 34.166C19.1925 34.2198 19.2642 34.166 19.0311 34.3633L18.9234 34.4351L18.762 34.5427L18.5647 34.6862C18.762 34.5427 18.4033 34.7938 18.3315 34.8476C18.2598 34.8835 18.2059 34.9194 18.1342 34.9732L18.0086 35.0629C17.9728 35.0808 17.919 35.1167 17.8831 35.1525C17.8831 35.1525 17.8293 35.2064 17.8113 35.2064C17.8831 35.1525 17.7216 35.2422 17.6499 35.296C17.5602 35.3319 17.4885 35.3678 17.4167 35.4216L17.1656 35.5472L17.058 35.601C16.9862 35.6368 17.0221 35.601 16.9503 35.6548C16.8786 35.7086 16.7889 35.7265 16.6992 35.7803C16.6095 35.8342 16.6992 35.7803 16.3943 35.9238C16.6992 35.7803 16.3943 35.9238 16.2329 35.9956C16.3943 35.9238 15.9459 36.1032 15.7485 36.175C15.6768 36.1929 15.2822 36.3185 15.2104 36.3364C15.1387 36.3543 15.049 36.3902 14.9772 36.4081C14.8337 36.444 14.7082 36.4799 14.5826 36.5158C14.5288 36.5337 14.475 36.5337 14.4391 36.5516L14.3494 36.5696L14.1342 36.6234C14.0624 36.6413 14.0086 36.6413 13.9369 36.6593C13.8651 36.6772 13.8113 36.6772 13.7575 36.6951C13.7037 36.7131 13.614 36.7131 13.5602 36.731C13.5243 36.731 13.4885 36.731 13.4705 36.749L13.327 36.7669H13.2553C13.2015 36.7669 13.1477 36.7848 13.0938 36.7848C13.04 36.7848 12.9503 36.8028 12.8786 36.8028H11.049C10.9772 36.8028 10.9055 36.7848 10.8337 36.7848C10.7799 36.7848 10.7261 36.7848 10.6723 36.7669H10.6006C10.5468 36.7669 10.4929 36.749 10.4571 36.749C10.4212 36.749 10.3853 36.749 10.3674 36.731C10.2956 36.731 10.2418 36.7131 10.1701 36.6951C10.1163 36.6951 10.0445 36.6772 9.9907 36.6593C9.93689 36.6413 9.86514 36.6413 9.79339 36.6234L9.57814 36.5696L9.48846 36.5516C9.43464 36.5516 9.38083 36.5337 9.34496 36.5158C9.20146 36.4799 9.0759 36.444 8.95034 36.4081L8.71716 36.3364C8.64541 36.3185 8.57366 36.3005 8.50191 36.2646C8.32254 36.2108 8.1611 36.1391 7.98173 36.0853C7.80236 36.0315 7.64092 35.9418 7.47949 35.87C7.40774 35.8342 7.31805 35.7983 7.22837 35.7624C7.13868 35.7265 7.04899 35.6907 6.97725 35.6368C6.88756 35.601 6.81581 35.5651 6.74406 35.5113C6.67231 35.4754 6.58263 35.4216 6.51088 35.3857C6.43913 35.3498 6.38532 35.314 6.33151 35.2781C6.15213 35.1705 6.04451 35.0987 6.15213 35.1705L6.04451 35.0987L5.8472 34.9732L5.77545 34.9373L5.59608 34.8117C5.52433 34.7579 5.45258 34.722 5.38083 34.6682C5.30908 34.6144 5.2194 34.5606 5.14765 34.5068C5.0759 34.453 5.00415 34.3812 4.95034 34.3454L4.87859 34.2916C4.80684 34.2557 4.75303 34.2019 4.69922 34.1481C8.34047 35.9597 10.2059 33.5561 11.1387 31.314C11.5333 30.3274 11.8203 29.305 11.9817 28.2646C12.1432 29.3229 12.466 30.3274 12.8786 31.314C13.7575 33.4157 15.623 35.9597 19.2642 34.166Z'
            fill='#fff'
        />
        <path
            d='M14.6548 36.4978C14.7983 36.4619 14.9238 36.426 15.0494 36.3901L14.6548 36.4978Z'
            fill='#fff'
        />
        <path
            d='M15.4976 36.2468C15.6769 36.1929 15.8384 36.1391 16.0177 36.0674C15.8384 36.1391 15.6769 36.1929 15.4976 36.2468Z'
            fill='#fff'
        />
        <path
            d='M15.9824 36.0855C16.1439 36.0137 16.3591 35.942 16.5205 35.8523C16.3412 35.942 16.1439 36.0137 15.9824 36.0855Z'
            fill='#fff'
        />
        <path
            opacity='0.6'
            d='M24 24.3006C23.9821 28.1212 22.2601 31.7266 19.3004 34.1481C15.6592 35.9598 13.7758 33.5741 12.843 31.332C12.4484 30.3454 12.1614 29.323 12 28.2827L23.6413 21.3948C23.8744 22.3454 24 23.3141 24 24.3006Z'
            fill='#fff'
        />
    </svg>
);

export default Portis;
